<template>
  <div>
    <v-container fluid :style="{ 'min-height': '800px' }">
      <v-container class="contain-width">

        <v-row>
          <v-col
              cols="12"
              md="8"
              offset-md="2"
              lg="6"
              offset-lg="3"
          >
            <h1 class="mt-6 mb-6">Help Centre</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>

<script>

import Footer from './Footer.vue'
import PrivacyPolicyContent from "./PrivacyPolicyContent.vue";
import {i18n} from "../i18n";

export default {
  name: "PrivacyPolicy",
  components: {
    'Footer': Footer
  },
  metaInfo() {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - Help Centre',
      htmlAttrs: {
        lang: i18n.locale
      },
      meta: [
        {
          name: 'description',
          content: "Use our help centre to find help or contact us."
        }
      ]
    }
  },
  mounted() {

    window.scrollTo(0,0);

    window.prerenderReady = true;
  },
}

</script>

<style scoped>

</style>
